const messages = {
  name: {
    presence: 'Nimi ei saa olla tyhjä.',
    length: 'Teksti on liian pitkä. Max 500 merkkiä.'
  },
  description: {
    length: 'Kuvaus on liian pitkä. Max 10000 merkkiä.'
  },
  participant: {
    length: 'Teksti on liian pitkä. Max 2000 merkkiä.'
  },
  eventLocation: {
    presence: 'Harjoituksella pitää olla sijainti.'
  },
  scope: {
    presence: 'Määritä laajuus.'
  },
  executor: {
    length: 'Teksti on liian pitkä. Max 2000 merkkiä.'
  },
  contact_name: {
    presence: 'Anna yhteyshenkilön nimi.',
    length: 'Teksti on liian pitkä. Max 2000 merkkiä.'
  },
  contact_email: {
    presence: 'Anna yhteyshenkilön sähköpostiosoite.',
    notEmail: 'ei ole sähköpostiosoite.'
  },
  start_date: {
    presence: 'Määritä aloitusajankohta.',
    startBeforeEnd: 'Aloitusajankohta ei voi olla lopetusajankohdan jälkeen.'
  },
  end_date: {
    presence: 'Määritä lopetusajankohta.',
    startBeforeEnd: 'Aloitusajankohta ei voi olla lopetusajankohdan jälkeen.'
  },
  link: {
    length: 'Linkin tai linkin tekstin pituus max. 2000 merkkiä.'
  }
};

export default messages;



// WEBPACK FOOTER //
// ./src/services/validationMessages.jsx